import * as React from "react";
import { Classes, NumericInput, Radio } from "../../externals";
import { defYearlyCronFirst, defYearlyCronSecond } from "../defaultCronOptions";
import { StartsAtSelector } from "../customInputs/StartsAtSelector";
import { Months } from "../../../entities";
import { DayNumDaySelector } from "../customInputs/DayNumDaySelector";
export class YearlyPanel extends React.PureComponent {
    constructor(props) {
        super(props);
        this.onChangeYearly = (cron, value, type) => {
            switch (type) {
                case "month":
                    cron.month = value;
                    break;
                case "monthday":
                    cron.monthday = value;
                    break;
                case "weekday":
                    cron.weekday = value;
                    break;
            }
            this.props.onChange(cron);
        };
        this.state = {
            yearlyFirstOpt: true,
        };
    }
    render() {
        const cron = Object.assign({}, this.props.cron);
        return (React.createElement("div", { id: "yearlyPanel" },
            React.createElement("div", { id: "yearlyFirstOpt", className: "tab-option-inline " },
                React.createElement(Radio, { label: "Every", checked: this.state.yearlyFirstOpt, onChange: () => {
                        this.setState({ yearlyFirstOpt: true });
                        this.props.onChange(Object.assign(Object.assign({}, defYearlyCronFirst), { minutes: this.props.startsAt[1], hours: this.props.startsAt[0] }));
                    }, className: "option-item", style: { paddingTop: "8px" } }),
                React.createElement("div", { className: `${Classes.SELECT} option-item` },
                    React.createElement("select", { onChange: (e) => {
                            this.onChangeYearly(cron, (Object.keys(Months).indexOf(e.target.value) + 1).toString(), "month");
                        }, disabled: !this.state.yearlyFirstOpt }, Object.keys(Months).map((value, index) => (React.createElement("option", { key: `${value}_${index}`, value: value, label: Months[value] }))))),
                React.createElement(NumericInput, { allowNumericCharactersOnly: false, max: 31, min: 1, value: this.state.yearlyFirstOpt ? cron.monthday : "1", onValueChange: (value) => this.onChangeYearly(cron, value.toString(), "monthday"), disabled: !this.state.yearlyFirstOpt })),
            React.createElement("div", { id: "yearlySecondOpt", className: "tab-option-inline", style: { paddingTop: "8px" } },
                React.createElement(Radio, { label: "The", checked: !this.state.yearlyFirstOpt, onChange: () => {
                        this.setState({ yearlyFirstOpt: false });
                        this.props.onChange(Object.assign(Object.assign({}, defYearlyCronSecond), { minutes: this.props.startsAt[1], hours: this.props.startsAt[0] }));
                    }, className: "option-item", style: { paddingTop: "8px" } }),
                React.createElement(DayNumDaySelector, { currentWeekday: cron.weekday, onChange: (value) => this.onChangeYearly(cron, value, "weekday"), disabled: this.state.yearlyFirstOpt }),
                React.createElement("label", { className: "option-item" }, "of"),
                React.createElement("div", { className: Classes.SELECT },
                    React.createElement("select", { className: "option-item", onChange: (e) => {
                            this.onChangeYearly(cron, (Object.keys(Months).indexOf(e.target.value) + 1).toString(), "month");
                        }, disabled: this.state.yearlyFirstOpt }, Object.keys(Months).map((value, index) => (React.createElement("option", { key: `${value}_${index}`, value: value, label: Months[value] })))))),
            React.createElement(StartsAtSelector, { startsAt: this.props.startsAt, startsAtChange: (value) => this.props.startsAtChange(value) })));
    }
}
//# sourceMappingURL=YearlyPanel.js.map